import { createMuiTheme, fade } from '@material-ui/core';
import { theme as newTheme } from '@ori-ui/material-ui';

import { theme } from '~/theme/ori/oriThemeStyles';

// const DISABLED_ALPHA = 0.8;
const READ_ONLY_ALPHA = 0.6;

export const customThemeColors = {
  alabaster: '#fafafa',
  alto: '#d8d8d8',
  black: '#000000',
  chalky: '#ecd898',
  chatelle: '#b3b0c4',
  chromeWhite: '#e1efce',
  doveGray: '#666666',
  earlsGreen: '#a9c23f',
  edgewater: '#b9dcd2',
  greenSpring: '#bac5b9',
  mineShaft: '#333333',
  newOrleans: '#f0bf9b',
  oxfordBlue: '#3C4858',
  pigeonPost: '#a7bcd6',
  seance: '#9c27b0',
  shiraz: '#c00d1e',
  silver: '#c0c0c0',
  tacha: '#bbd05e',
  white: '#ffffff',
  wildSand: '#f5f5f5',

  /* social colors */
  facebook: '#3B5998',
  google: '#dd4630',
  vkontakte: '#44668f',
  wechat: '#7bb32e',

  /* semantic colors */
  primary: '#000000',
  secondary: 'mineShaft',
};

export const customTheme = createMuiTheme(theme, {
  breakpoints: { ...newTheme.breakpoints },
  overrides: {
    MuiButton: {
      disabled: {},
      label: {
        lineHeight: 1,
        padding: 0,
      },
      text: {
        [newTheme.breakpoints.down(640)]: {
          minWidth: 0,
          width: '100%',
        },
        '&$disabled': {
          backgroundColor: '#E5E5E5',
          borderColor: '#E5E5E5',
          color: customThemeColors.white,
        },
        border: `2px solid ${customThemeColors.earlsGreen}`,
        borderRadius: '22.5px',
        fontSize: '14px',
        padding: '13.5px 15px',
        width: '330px',
      },
      textPrimary: {
        '&:hover': {
          '@media (hover: none)': {
            backgroundColor: customThemeColors.earlsGreen,
          },
        },
      },
      textSecondary: {
        [newTheme.breakpoints.down(640)]: {
          minWidth: 0,
          width: '100%',
        },
        backgroundColor: customThemeColors.white,
        borderColor: '#E5E5E5',
        borderRadius: '22.5px',
        color: customThemeColors.mineShaft,
        fontSize: '14px',
        padding: '13.5px 15px',
        width: '330px',
      },
    },
    MuiDialog: {
      paper: {
        [newTheme.breakpoints.down(0)]: {
          padding: '30px 15px',
        },
        margin: '15px',
        padding: '30px 60px',
      },
      paperWidthFalse: {
        maxWidth: 'calc(100% - 30px)',
        width: '420px', // + 2x60px padding = wanted 540px
      },
      paperWidthMd: {
        maxWidth: 'calc(100% - 30px)',
        padding: '0',
        width: '480px',
      },
    },
    MuiDialogActions: {
      root: {
        flexDirection: 'column',
        padding: '15px 0 0',
      },
    },
    MuiDialogContent: {
      root: {
        padding: '0 0 15px',
      },
    },
    MuiDialogTitle: {
      root: {
        padding: '0 0 15px',
        textAlign: 'center',
      },
    },
    MuiIcon: {
      root: {
        fontSize: '24px',
      },
    },
    MuiIconButton: {
      root: {
        color: 'inherit',
        padding: '10px',

        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
    },
    MuiInputBase: {
      input: {
        fontSize: '14px',
        lineHeight: '19px',
        padding: '10px 0',

        '&::placeholder': {
          color: '#cccccc',
          textTransform: 'none',
        },
        '&:read-only': {
          color: fade('#000000', READ_ONLY_ALPHA),
        },
      },
      root: {
        borderBottom: '1px solid #cccccc',
        color: customThemeColors.mineShaft,
        maxWidth: '100%',
        width: '330px',

        '&$disabled': {
          borderBottomColor: 'transparent',
        },
        '&$focused': {
          borderBottomColor: customThemeColors.earlsGreen,
        },
      },
    },
    MuiInputLabel: {
      root: {
        color: '#555555',
        fontSize: '12px',
        lineHeight: '20px',
      },
    },
    MuiLink: {
      root: {
        fontFamily: ['SansOri', 'Arial', 'Helvetica', 'sans-serif'].join(','),
        fontSize: '14px',
        fontWeight: 'bold',
        marginTop: '45px',
        textTransform: 'uppercase',
      },
      underlineAlways: {
        borderBottom: '2px solid #333',
        paddingBottom: '5px',
        textDecoration: 'none',
      },
    },
    MuiTypography: {
      body2: {
        color: '#333',
        fontSize: '15px',
        lineHeight: '21px',
      },
      h1: {
        fontSize: '34px',
        fontWeight: 'bold',
        lineHeight: '51px',
        marginBottom: '30px',
        marginTop: '30px',
        textAlign: 'center',
        color: '#333',
      },
      h3: {
        fontSize: '25px',
        fontWeight: 'bold',
        lineHeight: '32px',
      },
      h4: {
        color: '#333',
        fontSize: '16px',
        fontWeight: 'normal',
        lineHeight: '23px',
        textAlign: 'center',
      },
    },
    MuiTableCell: {
      body: {
        [newTheme.breakpoints.down(640)]: {
          verticalAlign: 'middle',
          padding: '20px 14px',
        },
        verticalAlign: 'top',
        padding: '30px',
      },
    },
  },
});
